export const QUESTION_TYPES = {
    MULTIPLE_CHOICE: 'multiple_choice',
    TRUE_FALSE: 'true_false',
    MATCH_PAIRS: 'match_pairs',
    ORDER_EVENTS: 'order_events',
};
